/** Terms version stamped when users accept compliance policies. */
export const TERMS_VERSION = "2026-10-13";

/**
 * Stripe dating/matchmaking is prohibited in these jurisdictions.
 * Match against profile.country (name or ISO code).
 */
export const DATING_PROHIBITED_COUNTRY_CODES = new Set(["IN", "AE", "TH", "MY"]);

const PROHIBITED_COUNTRY_ALIASES = new Map([
  ["india", "IN"],
  ["in", "IN"],
  ["united arab emirates", "AE"],
  ["uae", "AE"],
  ["ae", "AE"],
  ["emirates", "AE"],
  ["thailand", "TH"],
  ["th", "TH"],
  ["malaysia", "MY"],
  ["my", "MY"],
]);

export function normalizeCountryToCode(country) {
  if (!country || typeof country !== "string") return null;
  const raw = country.trim();
  if (!raw) return null;
  const lower = raw.toLowerCase();
  if (PROHIBITED_COUNTRY_ALIASES.has(lower)) {
    return PROHIBITED_COUNTRY_ALIASES.get(lower);
  }
  if (/^[a-z]{2}$/i.test(raw)) return raw.toUpperCase();
  return null;
}

export function isDatingProhibitedCountry(country) {
  const code = normalizeCountryToCode(country);
  if (code && DATING_PROHIBITED_COUNTRY_CODES.has(code)) return true;
  const lower = String(country || "").trim().toLowerCase();
  return (
    lower === "india" ||
    lower === "thailand" ||
    lower === "malaysia" ||
    lower === "united arab emirates" ||
    lower === "uae" ||
    lower.includes("emirates")
  );
}

export const REPORT_REASONS = [
  "harassment",
  "spam_scam",
  "underage",
  "explicit_content",
  "other",
];

export const COMPLIANCE_PENDING_KEY = "payinapo_compliance_pending";

export function readPendingCompliance() {
  try {
    const raw = sessionStorage.getItem(COMPLIANCE_PENDING_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function writePendingCompliance(payload) {
  try {
    sessionStorage.setItem(COMPLIANCE_PENDING_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function clearPendingCompliance() {
  try {
    sessionStorage.removeItem(COMPLIANCE_PENDING_KEY);
  } catch {
    /* ignore */
  }
}

export function buildComplianceAttestationPayload({ accepted = true } = {}) {
  if (!accepted) return {};
  const now = new Date().toISOString();
  return {
    termsAcceptedAt: now,
    ageAttestedAt: now,
    termsVersion: TERMS_VERSION,
  };
}
